import {handleActions} from 'redux-actions'
import {updateApps, cancelPermissions} from './actions'

export const initialState = {
  loaded: false,
  apps: []
}

export default handleActions(
  {
    [updateApps](state, {payload}) {
      return {
        ...state,
        loaded: !!payload,
        apps: payload || []
      }
    },

    [cancelPermissions](state, {payload}) {
      return {
        ...state,
        apps: state.apps.filter((app) => app.clientId !== payload)
      }
    }
  },
  initialState
)
